import { render, staticRenderFns } from "./LockableImage.vue?vue&type=template&id=2589383f&scoped=true"
import script from "./LockableImage.vue?vue&type=script&lang=js"
export * from "./LockableImage.vue?vue&type=script&lang=js"
import style0 from "./LockableImage.vue?vue&type=style&index=0&id=2589383f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2589383f",
  null
  
)

export default component.exports